"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[46383],{

/***/ 37915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79794);




var UserName = function(email) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""), name = ref[0], setName = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var docRef, docValue, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!email) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    docRef = components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_1__/* .projectFirestore.collection */ .H.collection("users").doc(email);
                    return [
                        4,
                        docRef.get()
                    ];
                case 2:
                    docValue = _state.sent();
                    if (docValue.exists) {
                        if (docValue.data().name !== "") setName(docValue.data().name);
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        email
    ]);
    return name;
};
/* harmony default export */ __webpack_exports__["Z"] = (UserName);


/***/ }),

/***/ 64410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79794);




var UserPhoto = function(email) {
    /* photo url 저장 */ var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("/images/market/no-img.png"), url = ref[0], setUrl = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var docRef, docValue, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!email) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    docRef = components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_1__/* .projectFirestore.collection */ .H.collection("users").doc(email);
                    return [
                        4,
                        docRef.get()
                    ];
                case 2:
                    docValue = _state.sent();
                    if (docValue.exists) {
                        if (docValue.data().photo !== "") setUrl(docValue.data().photo);
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        email
    ]);
    return url;
};
/* harmony default export */ __webpack_exports__["Z"] = (UserPhoto);


/***/ }),

/***/ 20137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79794);




var UserUid = function(email) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""), uid = ref[0], setUid = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var docRef, docValue, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!email) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    docRef = components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_1__/* .projectFirestore.collection */ .H.collection("users").doc(email);
                    return [
                        4,
                        docRef.get()
                    ];
                case 2:
                    docValue = _state.sent();
                    if (docValue.exists) {
                        if (docValue.data().id !== "") setUid(docValue.data().id);
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        email
    ]);
    return uid;
};
/* harmony default export */ __webpack_exports__["Z"] = (UserUid);


/***/ }),

/***/ 17843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_awesome_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20890);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);




/* 보관함 모달 */ var ArchiveModal = function(param) {
    var modalVisible = param.modalVisible, closeModal = param.closeModal;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_awesome_modal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        visible: modalVisible,
        width: "450",
        height: "250",
        effect: "fadeInUp",
        onClickAway: function() {
            return closeModal();
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "popup-wrap",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "popup-content",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "popup-header"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "popup-body flex flex-col justify-center items-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "text-2xl text-primary font-bold font-gmarket-medium",
                                id: "modal-title",
                                children: "내 보관함에 추가되었습니다"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "mb-0 text-888 font-gmarket-medium",
                                children: "보관된 앱은 보관함 메뉴에서 확인 가능합니다"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "popup-footer",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                type: "button",
                                className: "btn btn-modal-o w-1/2 mr-2",
                                onClick: function() {
                                    return closeModal();
                                },
                                children: "확인"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                href: "/archive",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "btn btn-grayPrimary w-1/2",
                                    children: "보관함으로"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArchiveModal);


/***/ }),

/***/ 39696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_modal_MaterialModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81268);
/* harmony import */ var _material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33426);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80366);






/* 문의하기 모달 */ var InquireModal = function(param) {
    var modalVisible = param.modalVisible, closeModal = param.closeModal, handleModalOkButton = param.handleModalOkButton, title = param.title, setTitle = param.setTitle, content = param.content, setContent = param.setContent;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_modal_MaterialModal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        open: modalVisible,
        closeModal: closeModal,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "popup-content m-0 modal-width-180",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "popup-header",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        "aria-label": "close",
                        className: "w-15 h-15",
                        onClick: closeModal,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "popup-body flex flex-col justify-center items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                            className: "text-primary font-gmarket-medium text-2xl font-bold mb-4",
                            children: "문의하기"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                label: "제목",
                                placeholder: "문의 제목을 입력하세요",
                                fullWidth: true,
                                value: title,
                                onChange: function(e) {
                                    return setTitle(e.target.value);
                                },
                                margin: "normal",
                                InputLabelProps: {
                                    shrink: true
                                },
                                className: "mt-4 w-full"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full py-3",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                label: "내용",
                                placeholder: "문의 내용을 입력하세요",
                                fullWidth: true,
                                value: content,
                                onChange: function(e) {
                                    return setContent(e.target.value);
                                },
                                multiline: true,
                                rows: 8,
                                className: "mt-4 w-full",
                                InputLabelProps: {
                                    shrink: true
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "popup-footer center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        className: "btn btn-modal-o w-2/5",
                        onClick: function() {
                            return handleModalOkButton();
                        },
                        children: "보내기"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InquireModal);


/***/ }),

/***/ 95547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_modal_MaterialModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81268);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);




/* 로그인 모달 */ var LoginModal = function(param) {
    var modalVisible = param.modalVisible, closeModal = param.closeModal;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_modal_MaterialModal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        open: modalVisible,
        closeModal: closeModal,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "popup-content",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "popup-header"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "popup-body flex flex-col justify-center items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "text-2xl text-primary font-bold font-gmarket-medium",
                            id: "modal-title",
                            children: "로그인 후 이용하실 수 있습니다."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mb-0 text-888 font-gmarket-medium",
                            children: "로그인하기 버튼을 클릭하여 아이소 로그인해주세요."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "popup-footer",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            type: "button",
                            className: "btn btn-modal-o w-1/2 mr-2",
                            onClick: closeModal,
                            children: "확인"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                            href: "/signin",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "btn btn-grayPrimary w-1/2",
                                children: "로그인하기"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoginModal);


/***/ }),

/***/ 81268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5566);
/* harmony import */ var components_modal_ModalFade__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4534);
/* harmony import */ var _material_ui_core_Backdrop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32692);





var MaterialModal = function(param) {
    var children = param.children, open = param.open, closeModal = param.closeModal;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        "aria-labelledby": "spring-modal-title",
        "aria-describedby": "spring-modal-description",
        className: "popup-wrap",
        open: open,
        onClose: closeModal,
        closeAfterTransition: true,
        disableScrollLock: true,
        BackdropComponent: _material_ui_core_Backdrop__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
        outline: 0,
        BackdropProps: {
            timeout: 500
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_modal_ModalFade__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            in: open,
            className: "center2",
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MaterialModal);


/***/ }),

/***/ 4534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_spring__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39920);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);







/* Material-UI 모달 Fade */ var ModalFade = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function Fade(props, ref) {
    var open = props.in, children = props.children, onEnter = props.onEnter, onExited = props.onExited, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, [
        "in",
        "children",
        "onEnter",
        "onExited"
    ]);
    var style = (0,react_spring__WEBPACK_IMPORTED_MODULE_2__.useSpring)({
        config: {
            duration: 10
        },
        from: {
            opacity: 0
        },
        to: {
            opacity: open ? 1 : 0
        },
        onStart: function() {
            if (open && onEnter) {
                onEnter();
            }
        },
        onRest: function() {
            if (!open && onExited) {
                onExited();
            }
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_spring__WEBPACK_IMPORTED_MODULE_2__.animated.div, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref,
        style: style
    }, other), {
        children: children
    }));
});
ModalFade.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().element),
    in: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool.isRequired),
    onEnter: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func),
    onExited: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func)
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalFade);


/***/ }),

/***/ 49957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_modal_MaterialModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81268);
/* harmony import */ var _material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33426);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80366);






/* 신고하기 모달 */ var ReportModal = function(param) {
    var modalVisible = param.modalVisible, closeModal = param.closeModal, handleModalOkButton = param.handleModalOkButton, title = param.title, setTitle = param.setTitle, content = param.content, setContent = param.setContent;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_modal_MaterialModal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        open: modalVisible,
        closeModal: closeModal,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "popup-content m-0 modal-width-180",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "popup-header",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-full",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            "aria-label": "close",
                            className: "w-15 h-15",
                            onClick: closeModal,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                    className: "text-danger font-gmarket-medium text-2xl font-bold mb-4 center",
                    children: "신고하기"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "popup-body flex flex-col justify-center items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                label: "제목",
                                placeholder: "신고할 내용의 제목을 입력하세요",
                                fullWidth: true,
                                value: title,
                                onChange: function(e) {
                                    return setTitle(e.target.value);
                                },
                                margin: "normal",
                                InputLabelProps: {
                                    shrink: true
                                },
                                className: "mt-4 w-full"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full py-3",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                label: "내용",
                                placeholder: "신고 내용을 입력하세요",
                                fullWidth: true,
                                value: content,
                                onChange: function(e) {
                                    return setContent(e.target.value);
                                },
                                multiline: true,
                                rows: 8,
                                className: "mt-4 w-full",
                                InputLabelProps: {
                                    shrink: true
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "popup-footer center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        className: "btn btn-modal-x w-2/5",
                        onClick: function() {
                            return handleModalOkButton();
                        },
                        children: "보내기"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReportModal);


/***/ }),

/***/ 76195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80366);
/* harmony import */ var _material_ui_icons_Facebook__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(83792);
/* harmony import */ var _material_ui_icons_Twitter__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(44704);
/* harmony import */ var _material_ui_icons_Link__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(66081);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_Alert__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34950);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74855);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var components_KakaoShare__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37276);
/* harmony import */ var components_modal_MaterialModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81268);






// ShareIcon








var ShareModal = function(param) {
    var open = param.open, handleClose = param.handleClose, path = param.path, title = param.title, description = param.description;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    // const basicUrl = "aiso-api.du.r.appspot.com";
    var basicUrl = "aiso.ai";
    var linkUrl = path ? basicUrl.concat(path) : basicUrl.concat(router.asPath);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (0,components_KakaoShare__WEBPACK_IMPORTED_MODULE_5__/* .initKakao */ .$)();
    }, []);
    var handleKakaoShare = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function() {
            var sendLinkUrl;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                sendLinkUrl = "https://".concat(linkUrl);
                (0,components_KakaoShare__WEBPACK_IMPORTED_MODULE_5__/* .shareKakao */ .L)(sendLinkUrl, title, description);
                return [
                    2
                ];
            });
        });
        return function handleKakaoShare() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_modal_MaterialModal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        open: open,
        closeModal: handleClose,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "popup-content max-w-xl",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "popup-header",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-full",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            "aria-label": "close",
                            className: "w-15 h-15",
                            onClick: handleClose,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "popup-body flex flex-col justify-center items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                            className: "text-333 font-gmarket-medium text-2xl font-bold mb-4",
                            children: "Share"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "row w-full",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-6 col-sm-3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "share-card p-3",
                                        onClick: function() {
                                            handleClose();
                                            // const linkUrl = `aiso-api.du.r.appspot.com${router.asPath}`;
                                            window.open("https://www.facebook.com/sharer.php?u=" + encodeURIComponent(linkUrl));
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "face-share-icon",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Facebook__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                    fontSize: "large"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mb-0 font-gmarket-medium text-xs text-888 mt-3",
                                                children: "facebook"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-6 col-sm-3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "share-card p-3",
                                        onClick: handleKakaoShare,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "kakao-share-icon",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    style: {
                                                        width: "40px",
                                                        height: "40px"
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        className: "p-1",
                                                        src: "/images/market/kakaotalk.svg",
                                                        alt: ""
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mb-0 font-gmarket-medium text-xs text-888 mt-3",
                                                children: "Kakao Talk"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-6 col-sm-3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "share-card p-3",
                                        onClick: function() {
                                            handleClose();
                                            window.open("https://twitter.com/intent/tweet/?url=" + encodeURIComponent(linkUrl));
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "twitter-share-icon",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Twitter__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                    fontSize: "large"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mb-0 font-gmarket-medium text-xs text-888 mt-3",
                                                children: "Twitter"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-6 col-sm-3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_4__.CopyToClipboard, {
                                        text: "https://".concat(linkUrl),
                                        onCopy: function() {
                                            (0,components_Alert__WEBPACK_IMPORTED_MODULE_3__/* .BasicAlert */ .N)("클립보드에 복사되었습니다.");
                                            handleClose();
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "share-card p-3",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "twitter-share-icon",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Link__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                        fontSize: "large"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "mb-0 font-gmarket-medium text-xs text-888 mt-3",
                                                    children: "Copy Link"
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "popup-footer"
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ShareModal);


/***/ })

}]);